<template>
  <div class="form-edit-form">
    <form novalidate class="md-layout" @submit.prevent="validate">

      <md-field :class="getValidationClass('name')">
        <label for="name">Form Name</label>
        <md-input type="name" name="name" id="name" autocomplete="name" v-model="form.name" :disabled="sending" />
        <span class="md-error" v-if="!$v.form.name.required">The form name is required</span>
        <span class="md-error" v-if="!$v.form.name.maxLength">The form name must be less than 80 characters</span>
      </md-field>
      <span class="md-info"></span>

      <div>
        <md-checkbox id="archived" v-model="form.archived" :disabled="sending" class="md-primary">Archived</md-checkbox>
        <span class="md-info">Archived forms will not receive any submissions</span>
      </div>

      <datepicker v-model="form.active_from">
        <label>Active After (Optional)</label>
      </datepicker>
      <span class="md-info">If set submissions will only be accepted after the specified date.</span>

      <datepicker v-model="form.active_to">
        <label>Active Until (Optional)</label>
      </datepicker>
      <span class="md-info">If set submissions will only be accepted before the specified date.</span>

      <md-field :class="getValidationClass('redirect_link_success')">
        <label for="redirect_link_success">Redirect Link On Success (Optional)</label>
        <md-input type="url" name="redirect_link_success" id="name" autocomplete="redirect_link_success" v-model="form.redirect_link_success" :disabled="sending" />
        <span class="md-error" v-if="!$v.form.name.required">The form name is required</span>
        <span class="md-error" v-if="!$v.form.name.url">You need to specify a valid url</span>
      </md-field>
      <span class="md-info">Users will be sent here after a successful submission. If you want to use our default confirmation page, you can just leave this blank.</span>

      <md-field :class="getValidationClass('redirect_link_error')">
        <label for="redirect_link_error">Redirect Link On Failure (Optional)</label>
        <md-input type="url" name="redirect_link_error" id="name" autocomplete="redirect_link_error" v-model="form.redirect_link_error" :disabled="sending" />
        <span class="md-error" v-if="!$v.form.name.required">The form name is required</span>
        <span class="md-error" v-if="!$v.form.name.url">You need to specify a valid url</span>
      </md-field>
      <span class="md-info">Users will be sent here after a failed submission. If you want to use our default confirmation page, you can just leave this blank.</span>

      <error-container :error="error"></error-container>

      <div class="md-layout md-alignment-top-right">
        <md-button type="submit" class="md-raised md-primary" :disabled="sending">Update</md-button>
      </div>

      <md-snackbar :md-active.sync="isSaved">The form was updated successfully!</md-snackbar>
    </form>
  </div>
</template>

<script>
import ErrorContainer from '../ErrorContainer'
import Datepicker from '../Datepicker'
import ErrorFactory from '../../models/ErrorFactory'
import { validationMixin } from 'vuelidate'
import {
  required,
  maxLength,
  url
} from 'vuelidate/lib/validators'
export default {
  name: 'FormEditForm',
  mixins: [validationMixin],
  components: {
    ErrorContainer,
    Datepicker
  },
  props: {
    currentForm: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: () => ({
    form: {
      name: null,
      archived: false,
      active_from: null,
      active_to: null,
      redirect_link_success: null,
      redirect_link_error: null
    },
    isSaved: false,
    sending: false,
    error: null,
    errorFactory: new ErrorFactory()
  }),
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(80)
      },
      archived: {
        required
      },
      redirect_link_success: {
        url
      },
      redirect_link_error: {
        url
      }
    }
  },
  mounted () {
    this.form.name = this.currentForm.name
    this.form.archived = this.currentForm.archived
    this.form.active_from = this.currentForm.active_from
    this.form.active_to = this.currentForm.active_to
    this.form.redirect_link_success = this.currentForm.redirect_link_success
    this.form.redirect_link_error = this.currentForm.redirect_link_error
  },
  computed: {
    axios () {
      return this.$store.getters['axios']
    },
    base_url () {
      return this.$store.getters['base_url']
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.name = null
      this.archived = false
      this.active_from = null
      this.active_to = null
      this.redirect_link_success = null
      this.redirect_link_error = null
    },
    async send () {
      this.sending = true
      try {
        const { data } = await this.axios.put(this.base_url + '/forms/' + this.currentForm.id, {
          name: this.form.name,
          archived: this.form.archived,
          active_from: this.form.active_from,
          active_to: this.form.active_to,
          redirect_link_success: this.form.redirect_link_success,
          redirect_link_error: this.form.redirect_link_error
        })

        if (!data || !data.token) {
          throw new Error()
        }

        this.isSaved = true
        this.$store.dispatch('fetchCurrentForm', this.currentForm.id)
      } catch (error) {
        this.error = this.errorFactory.make(error.response.data, 'Update failed')
      } finally {
        this.sending = false
      }
    },
    validate () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.send()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .no-shadow  {
    box-shadow: none;
  }
  .md-title {
    text-align: left;
  }
  .md-info {
    color: #999;
    width: 100%;
    display: block;
    margin-bottom: 10px;
  }
  .md-button {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/FormEditForm.vue